<script lang="ts">
    import Waiting from "../../Waiting/Waiting.svelte";
    import { onDestroy } from "svelte";
    import CallHeader from "../CallHeader.svelte";
    import CallRemoteVideo from "../CallRemoteVideo.svelte";
    import { hangupPeerConnection } from "../../../stores/peerConnectionStore.js";
    import { roomStore } from "../../../stores/roomStore";
    import { translation } from "../../../stores";
    import ExpertCall from "../Mode/Expert/ExpertCall.svelte";

    $: room = $roomStore;

    onDestroy(() => {
        console.log("[CallVideo][onDestroy]");
        hangupPeerConnection();
    });
</script>

{#if room}
    <CallHeader
        title={translation.alert.inCallExpert}
        roomId={room.id}
        roomType={room.type}
        audioEnabled={room.audioEnabled}
    />
    <div class="grid grid-cols-6 gap-2 p-4 bg-gray-100 rounded-lg shadow-lg">
        <div class="col-span-6">
            <CallRemoteVideo />
        </div>
        <div class="col-span-6">
            <ExpertCall />
        </div>
    </div>
{:else}
    <Waiting text={translation.alert.waitingAuthorization} />
{/if}
